#import "./CanvasBlockBaseFields.graphql"

fragment MetricBlockFields on MetricBlock {
  ...CanvasBlockBaseFields
  metrics {
    label
    value
    change
    trend
  }
}
